export const dateformatter = (createdAt) => {
  const date = new Date(createdAt);
  return `${date.toLocaleString("en-us", {
    day: "2-digit",
  })} ${date.toLocaleString("en-us", {
    month: "long",
  })}, ${date.getFullYear()}`;
};

export const changeDateFormat = (date) => {
  const day =
    parseInt(new Date(date).getDate()) < 10
      ? `0${new Date(date).getDate()}`
      : new Date(date).getDate();
  const month =
    parseInt(new Date(date).getMonth()) < 10
      ? `0${new Date(date).getMonth() + 1}`
      : new Date(date).getMonth() + 1;
  const year = new Date(date).getFullYear();

  return `${year}-${month}-${day}`;
};
